export default "__VITE_ASSET__Dgwm3AzT__"